import React from "react";
import { inject } from "mobx-react";
import {
  FormGroup,
  Input,
  Button,
  Row,
  Col,
} from "reactstrap";

import OrganizationsComponent from "./OrganizationsComponent";
import LoadingComponent from "../../components/LoadingComponent";
import { USER_LEVEL } from "../../configs/constants";
import AlertComponent from "~/components/AlertComponent";
import PaginationComponent from "../../components/PaginationComponent";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { autoCompleteSx } from '../../helpers/utils'

@inject("OrganizationStore", "UserStore")
class OrganizationsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      filter: "",
      organizations: [],
    };
  }

  async componentDidMount() {
    this.getOrganizations();
  }

  getOrganizations = async (skip) => {
    this.setState({
      isLoading: true,
    });

    if (skip === undefined) skip = 0;

    let { filter, resale } = this.state;
    const { OrganizationStore } = this.props;
    const data = await OrganizationStore.getOrganizations(filter, 0, undefined, skip, resale?.organizationId);    
    let countItems = 0;
    let currentPage = 1;
    let countPages = 1;
    let organizations = [];
    if (data && data !== "" && data.organizations.length > 0) {
      organizations = data.organizations;
      countItems = data.countItems;
      countPages = data.countPages;
    }  
    let resales = await this.getResales("");
    if (resale === undefined) resale = resales[0];
    this.setState({
      skip: skip,
      countItems: countItems,
      countPages: countPages,
      currentPage: currentPage,
      organizations: organizations,
      resales: resales,
      resale: resale,
      isLoading: false,
    });
  };

  goOrganization = async (organizationId) => {
    const { history } = this.props;
    history.push(`organization?organizationId=${organizationId}`);
  };

  getResales = async (filter) => {
    const { OrganizationStore } = this.props;
    const resales = await OrganizationStore.getResales(filter);
    return resales;
  };

  onStatus = async (organizationId) => {
    this.setState({
      isLoading: true,
    });
    const { OrganizationStore } = this.props;
    const result = await OrganizationStore.statusUpdate(organizationId);
    this.setState({
      isLoading: false,
    });
    if (result === "true" || result === true) {
      this.getOrganizations();
      AlertComponent.success("Estabelecimento atualizado com sucesso");
    }
    else AlertComponent.error("Falha ao atualizar estabelecimento"); 
  };

  onChangeFilter = (e) => {
    this.setState({
      filter: e.target.value,
    });
  };

  onPageChange = async (currentPage) => {  
    this.setState({
      isLoading: true
    });  
    const skip = (currentPage - 1) * 100;
    await this.getOrganizations(skip);
    this.setState({
      currentPage: currentPage
    });
    this.setState({
      isLoading: false,
      skip: skip
    });
  };

  onKeyUpResale = async (value) => {
    try {
      let organizations = await this.getOrganizations(value);
      this.setState({
        organizations
      });
    }
    catch {}
  };

  onChangeResale = (organizationName) => {
    let { organizations, organization, skip } = this.state;
    for(let i = 0; i < organizations.length; i++){
      if (organizations[i].name === organizationName){
        organization = organizations[i];
        break;
      }
    }

    this.getDevices(organization, organizationName, skip);
  };

   onKeyUpResale = async (value) => {
    try {
      let resales = await this.getResales(value);
      this.setState({
        resales
      });
    }
    catch {}
  };

  onChangeResale = (resaleName) => {
    let { resales, resale } = this.state;
    for(let i = 0; i < resales.length; i++){
      if (resales[i].name === resaleName){
        resale = resales[i];
        break;
      }
    }
    this.setState({
      resale
    });

  };

  render() {
    const { UserStore } = this.props;
    const { isLoading, organizations, filter, currentPage, countItems, skip, resale, resales } = this.state;
    return (
      <>
        {(isLoading && (
          <>
            <LoadingComponent />
          </>
        )) || (
          <>         
          <div className="content content-xs">
            <Row>
              <Col xs={12} md={12}>
                <label>Filtro (Nome ou CNPJ)</label>
                <Input
                  name="filter"
                  type="text"
                  placeholder="Filtro"
                  value={filter}
                  onChange={(e) => this.onChangeFilter(e)}
                />
              </Col>
              {resales && resales.length > 0 && (
              <Col xs={12} md={12}>
                <FormGroup>
                  <span style={{marginBottom: "0px"}}>Revenda:</span>
                  <Autocomplete
                    freeSolo
                    noOptionsText={"Nenhum item"}
                    onChange={(event, value) =>                         
                      this.onChangeResale(value)
                    }
                    style={{paddingBottom: "10px"}}                                      
                    value={resale?.name}
                    id="resale"
                    options={resales.map((resale) => resale.name)}
                    isOptionEqualToValue={(option, value) => option.organizationId === value.organizationId}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        onInput={(e) => this.onKeyUpResale(e.target.value)}
                      />
                    )}
                    sx={autoCompleteSx()}
                    renderOption={(props, option) => {
                      return (
                        <span  {...props}>
                          {option}
                        </span>
                      );
                    }}                      
                  />
                </FormGroup>  
              </Col>
              )}
            </Row>
            <Row>
              <Col style={{marginTop: "5px"}}>            
                <Button
                  className="btn-fill btn-xs"
                  color="primary"
                  type="submit"
                  onClick={()=>this.getOrganizations(skip)}
                >
                  Buscar
                </Button>
              </Col>
            </Row>
            {UserStore.getLevel() === USER_LEVEL.manager ?
              <Row>                
                <Col style={{textAlign: "right"}}>
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="submit"
                    onClick={()=>this.goOrganization(0)}
                  >
                    Novo estabelecimento
                  </Button>
                </Col>
              </Row>
            : (<></>)}
            <Row>
              <Col xs={4} md={3} style={{lineHeight: "1"}}>
                CPF ou CNPJ
              </Col>
              <Col xs={4} md={4} style={{lineHeight: "1"}}>
              Nome
              </Col>
              <Col md={3} style={{lineHeight: "1"}} className="display-none-xs">
              Revenda
              </Col>
            </Row>
            <OrganizationsComponent
              userLevel={UserStore.getLevel()}
              organizations={organizations}
              onClick={this.goOrganization}
              onStatus={this.onStatus}
            />
            <PaginationComponent
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={countItems}
              onPageChange={this.onPageChange}
            />
          </div>         
          </>
        )}
      </>
    );
  }
}

export default OrganizationsContainer;
